import React from "react";
import { Link } from "react-router-dom";
import Reveal, { SectionTitle } from "../Reveal";
import { bestSellers, decor } from "../../data/mock";
import Img from "../Img";

export default function BestSellers() {
  return (
    <section
      data-testid="best-sellers"
      className="relative bg-[#2f3a33] py-24"
      style={{
        backgroundImage:
          "url(/images/2017_01_back11-800.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      aria-labelledby="best-selling-title"
    >
      <div className="absolute inset-0 bg-[#242c26]/85" />
      <div className="relative mx-auto max-w-[1200px] px-6">
        <Reveal>
          <div className="text-center">
            <h2
              id="best-selling-title"
              className="ah-heading text-[28px] !text-white sm:text-[34px]"
            >
              Best-selling
            </h2>
            <Img
              src={decor.delimWhite}
              alt=""
              aria-hidden="true"
              loading="lazy"
              className="mx-auto mt-5 h-[14px] w-auto"
            />
          </div>
        </Reveal>

        <div className="mt-14 grid gap-10 md:grid-cols-3">
          {bestSellers.map((b, i) => (
            <Reveal key={b.id} delay={i * 140}>
              <article className="ah-card group text-center">
                <div className="relative mx-auto h-[210px] w-[210px] overflow-hidden rounded-full ring-1 ring-white/25 ring-offset-4 ring-offset-transparent transition-all duration-500 group-hover:ring-[#a9bd58]">
                  <Img
                    src={b.image}
                    alt={`${b.name} - ${b.calo}`}
                    loading="lazy"
                    sizes="210px"
                    className="ah-card-img h-full w-full object-cover"
                  />
                </div>
                <h3 className="ah-heading mt-7 text-[17px] !text-white">{b.name}</h3>
                <p className="mt-2 text-[13px] tracking-wider text-[#a9bd58]">{`(${b.calo})`}</p>
                <Img
                  src={decor.delimSmallWhite}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  className="mx-auto mt-5 h-[10px] w-auto opacity-70"
                />
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-16 text-center">
            <Link to="/thuc-don" className="ah-btn ah-btn-outline">
              Xem menu tuần này
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
